"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Section_1 = __importDefault(require("../elements/Section"));
var Card_1 = __importDefault(require("../elements/Card"));
var Image_1 = __importDefault(require("../elements/Image"));
var VideoPlayer_1 = __importDefault(require("../elements/VideoPlayer"));
var Danke_1 = require("../../defaults/Danke");
var dayjs_1 = __importDefault(require("dayjs"));
require("dayjs/locale/de");
var _helpers_1 = require("../../helpers");
var react_1 = __importDefault(require("react"));
dayjs_1.default.locale('de');
var dateFormat = 'dddd, DD. MMMM YYYY, HH:mm';
var calendlyParams = function () {
    var _a, _b;
    var urlParams = new URLSearchParams(decodeURI(document.location.search));
    var start = dayjs_1.default((_a = urlParams.get('event_start_time')) === null || _a === void 0 ? void 0 : _a.toString());
    var end = dayjs_1.default((_b = urlParams.get('event_end_time')) === null || _b === void 0 ? void 0 : _b.toString());
    var data = {
        assigned_to: urlParams.get('assigned_to'),
        event_type_uuid: urlParams.get('event_type_uuid'),
        event_type_name: urlParams.get('event_type_name'),
        event_start_time: urlParams.has('event_start_time')
            ? start.format(dateFormat)
            : null,
        event_end_time: urlParams.has('event_end_time')
            ? end.format(dateFormat)
            : null,
        event_date: urlParams.has('event_start_time')
            ? start.format(dateFormat) + " - " + end.format('HH:mm')
            : null,
        invitee_uuid: urlParams.get('invitee_uuid'),
        invitee_full_name: urlParams.get('invitee_full_name'),
        invitee_email: urlParams.get('invitee_email')
    };
    return data;
};
var parseCalendlyParams = function (text) {
    var calendlyData = calendlyParams();
    return text
        .replace(':assigned_to:', calendlyData.assigned_to || '')
        .replace(':event_type_name:', calendlyData.event_type_name || '')
        .replace(':event_start_time:', calendlyData.event_start_time || '')
        .replace(':event_end_time:', calendlyData.event_end_time || '')
        .replace(':event_date:', calendlyData.event_date || '')
        .replace(':invitee_full_name:', calendlyData.invitee_full_name || '')
        .replace(':invitee_email:', calendlyData.invitee_email || '');
};
var Danke = function (_a) {
    var _b, _c, _d;
    var sectionConfig = _a.sectionConfig, headerCardConfig = _a.headerCardConfig, cardConfig = _a.cardConfig, children = _a.children, video = _a.video, image = _a.image;
    var mergedSectionConfig = _helpers_1.merge(Danke_1.defaultSectionConfig, sectionConfig);
    var mergedHeaderCardConfig = _helpers_1.merge(Danke_1.defaultHeaderCardConfig, headerCardConfig);
    var mergedCardConfig = _helpers_1.merge(Danke_1.defaultCardConfig, cardConfig);
    // Override Calendly placeholder
    if ((_b = mergedCardConfig === null || mergedCardConfig === void 0 ? void 0 : mergedCardConfig.descriptionConfig) === null || _b === void 0 ? void 0 : _b.text) {
        mergedCardConfig.descriptionConfig.text = parseCalendlyParams(((_c = mergedCardConfig.descriptionConfig) === null || _c === void 0 ? void 0 : _c.text) || '');
    }
    return (react_1.default.createElement(Section_1.default, __assign({}, mergedSectionConfig),
        ((_d = mergedHeaderCardConfig === null || mergedHeaderCardConfig === void 0 ? void 0 : mergedHeaderCardConfig.titleConfig) === null || _d === void 0 ? void 0 : _d.text) && (react_1.default.createElement(Card_1.default, __assign({}, mergedHeaderCardConfig))),
        react_1.default.createElement(Card_1.default, __assign({}, mergedCardConfig),
            react_1.default.createElement("div", { className: "columns is-multiline" },
                react_1.default.createElement("div", { className: "column is-12-mobile is-offset-2-desktop is-8-desktop" },
                    video && react_1.default.createElement(VideoPlayer_1.default, __assign({}, video)),
                    image && react_1.default.createElement(Image_1.default, __assign({}, image)))),
            children)));
};
exports.default = Danke;
//# sourceMappingURL=Danke.js.map